import CONSTANTS from "../../util/constants";

const initState = {
  isLoading: false,
  password: "",
  email: "",
  emailError: false,
  passwordError: false,
  modal: false,
  isRememberMeChecked: false,
  loginResponse: "",
  loginRolesData: [],
  forgotPasswordResponse: null,
  resetPasswordResponse: null,
  divisionStatsResponse: [],
};

const LoginReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE:
      return {
        ...state,
        isLoading: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD:
      return {
        ...state,
        password: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL:
      return {
        ...state,
        email: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_EMAIL_ERROR:
      return {
        ...state,
        emailError: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_PASSWORD_ERROR:
      return {
        ...state,
        passwordError: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.USER_LOGIN_SUCCEEDED:
      return {
        ...state,
        loginResponse: payload.value,
      };

    case CONSTANTS.CONSTANTS_LOGIN.USER_ROLES_DATA:
      return {
        ...state,
        loginRolesData: payload.value,
      };
    case CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_RESPONSE:
      return {
        ...state,
        divisionStatsResponse: payload.value,
      };
    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_FORGOT_PASSWORD_API_RESPONSE:
      return {
        ...state,
        forgotPasswordResponse: payload.value,
      };
    case CONSTANTS.CONSTANTS_LOGIN.LOGIN_CONFIRM_PASSWORD_API_RESPONSE:
      return {
        ...state,
        resetPasswordResponse: payload.value,
      };

    default:
      return state;
  }
};

export default LoginReducer;
